// extracted by mini-css-extract-plugin
export var container = "Footer-module--container--E4Jsm";
export var copyright = "Footer-module--copyright--253UK";
export var credit = "Footer-module--credit--3FUGp";